import { Button, Card } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const Product = (props) => {
  const normalPrice = parseInt(props.normalPrice);
  const discount =  parseInt(props.discount);
  return (
    <Card
      data-aos='fade-up'
      data-aos-delay = {props.delay}
      className='fav-product'
      style={{ width: 280, height: 500, borderRadius: '8px' }}
      cover={
        <div className='product-thumbnail'>
          <div className='product-image'>
            <Link to={props.link}>
              <img alt='example' src={props.image} />
            </Link>
          </div>
        </div>
      }
    >
      <h3>{props.name}</h3>
      <p className='price_normal'>Rp. {normalPrice.toLocaleString('id-ID')}</p>
      <p className='price_discount'>Rp. {discount.toLocaleString('id-ID')}</p>
      <Button type='primary' style={{ borderRadius: '4px' }}>
        <Link to={props.link}>Detail</Link>
      </Button>
    </Card>
  );
}

export default Product;